import {axiosWithToken} from './network.es6';
export const getItem = (id) => new Promise((resolve, reject) => {
    const post = {
        id: id,
    };
    axiosWithToken({url: '/gift/api/items/get_item', method: 'post', data: post})
        .then((response) => {
            if (response.data.status === 'TRUE') {
                resolve(response.data.item);
            } else {
                reject(response.data.userMessage)
            }
        })
        .catch((response) => {
            reject([response])
        });
});
export const search = (conditions) => new Promise((resolve, reject) => {
    const post = {
        conditions: conditions,
    };
    axiosWithToken({url: '/gift/api/items/search', method: 'post', data: post})
        .then((response) => {
            if (response.data.status === 'TRUE') {
                resolve(response.data);
            } else {
                reject(response.data.userMessage)
            }
        })
        .catch((response) => {
            reject([response])
        });
});
